import { render, staticRenderFns } from "./disttree.vue?vue&type=template&id=2f5dff53"
import script from "./disttree.vue?vue&type=script&lang=js"
export * from "./disttree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports